export class UsuarioInformacoes {
  confirmacaoEmail: boolean;
  boasVindas: boolean;
  confirmacaoTelefone: boolean;
}
